module.exports = "<div class=\"text-right m-t-20 m-b-20\">\n    <chassis-button [value]=\"'Create' | translate\" (click)=\"create()\"></chassis-button>\n</div>\n\n<div class=\"table-responsive\">\n    <chassis-datatable [ajax]=\"table?.ajax\" [serverSide]=\"true\" [datatables]=\"true\" [columns]=\"table?.columns\" [click]=\"table?.callbacks['click']\" (instance)=\"setDatatableInstance($event);\"></chassis-datatable>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./libs/donna-core/src/app/locations/plugins/location-settings/location-settings.plugin.html
// module id = ./libs/donna-core/src/app/locations/plugins/location-settings/location-settings.plugin.html
// module chunks = main